import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import { DataNIBChecklist } from "modules/Pu/services/DataNIBChecklist";
import { DataRegistration } from 'modules/Registration/services/types';
import { FC } from "react";

export interface CardPengajuanPuProps {
    className?: string;
    isLiked?: boolean;
    dataNIB?: DataNIBChecklist,
    oldsubmission?: DataRegistration;
}

const CardPengajuanPu: FC<CardPengajuanPuProps> = ({ className = "", isLiked, dataNIB, oldsubmission }) => {
    if (oldsubmission) {
        return (
            <div className="">
                <Disclosure defaultOpen>
                    {({ open }) => (
                        <>
                            <Disclosure.Button className="flex w-full justify-between">
                                <div className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                    <span>
                                        Pengajuan
                                        {/* # {oldsubmission.RefJenisProduk.RefDesc?.toString().toUpperCase()} */}
                                    </span>
                                    <ChevronUpIcon
                                        className={`${open ? 'rotate-180 transform' : ''
                                            } h-5 w-5 text-purple-500`}
                                    />
                                </div>
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                                {oldsubmission.NamaPuAlt}
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            </div >

        )
    }

    return (
        <div className="rounded-xl bg-white p-3 shadow-sm">
            <Disclosure>
                {({ open }) => (
                    <>
                        <Disclosure.Button className="flex w-full justify-between">
                            <div className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                <span>
                                    Pengajuan
                                    {/* # {dataNIB && dataNIB.dataProdukHalal.flagSelfDeclare === '1' ? 'Selfdeclare' : 'Reguler'} */}
                                </span>
                                <ChevronUpIcon
                                    className={`${open ? 'rotate-180 transform' : ''
                                        } h-5 w-5 text-purple-500`}
                                />
                            </div>
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                            {dataNIB?.dataProdukHalal.uraianJenisProduk}
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div >

    );
};

export default CardPengajuanPu;
